module.exports = __webpack_public_path__ + "img/image-1.e7c971d3.png";